var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('alert'),(_vm.showMenu)?_c('tophead'):_vm._e(),(_vm.showMenu)?_c('sidebar'):_vm._e(),_c('router-view',{staticClass:"router-view",style:({ height: _vm.viewHeigth + 'px' })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }